import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Routes, RouterModule } from "@angular/router";
import { HomeComponent } from "./pages/home/home.component";
import { GsfCalcComponent } from "../../calculator/gsf-calc/gsf-calc.component";
import { PillarComponent } from "../../calculator/pillar/pillar.component";

const routes: Routes = [
  {
    path: "home",
    component: HomeComponent,
    children: [
      {
        path: "GSF/:lang",
        component: GsfCalcComponent,
        children: [
          {
            path: ":pillarName",
            component: PillarComponent,
          },
        ],
      },

      {
        path: "gigaton-goals",
        loadChildren: () =>
          import("../../gigaton-goals/gigaton-goals.module").then(
            (m) => m.GigatonGoalsModule
          ),
        data: { portal: "external", breadcrumb: "Goals" },
      },
      {
        path: "people",
        loadChildren: () =>
          import("../../people/people.module").then(
            (m) => m.PeopleModule
          ),
      },
      {
        path: "carbon-footprint",
        loadChildren: () =>
          import("../../carbon-footprints/carbon-footprint.module").then(
            (m) => m.CarbonFootprintModule
          ),
      },
      {
        path: "commodities",
        loadChildren: () =>
          import("../../commodities/commodities.module").then(
            (m) => m.CommoditiesModule
          )
      }
    ],
  },
  // { path: "", redirectTo: "home/GSF/eng", pathMatch: "full" }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes),
  ],
  declarations: [],
  exports: [RouterModule],
})
export class HomeRoutingModule {}
